import img1 from "../../Assets/slides/Bahai_Shrine.jpg"
import img2 from "../../Assets/slides/Basilica of Annunciation.jpg"
import img3 from "../../Assets/slides/Beattitudes in Jerusalem.jpg"
import img4 from "../../Assets/slides/bethany.jpg"
import img5 from "../../Assets/slides/Bethlehem.jpg"
import img6 from "../../Assets/slides/BurningBush.jpg"
import img8 from "../../Assets/slides/Cairo.jpg"
import img9 from "../../Assets/slides/Cairo Museum.jpg"
import img10 from "../../Assets/slides/canan.jpg"
import img11 from "../../Assets/slides/Church Of Nativity.jpg"
import img12 from "../../Assets/slides/Church of StPeter of Gallicantu.jpg"
import img13 from "../../Assets/slides/David & Goliath Valey (Elah Valley).jpeg"
import img14 from "../../Assets/slides/Dead Sea.jpg"
import img15 from "../../Assets/slides/Dome of the Rock Temple Mount in Jerusalem.jpg"
import img16 from "../../Assets/slides/Dominous Flevit in Jerusalem.jpg"
import img17 from "../../Assets/slides/Elisha Springs in Jerusalem.jpg"
import img18 from "../../Assets/slides/Galiliean Boad Ride.jpg"
import img19 from "../../Assets/slides/Garden of Gathsemane.jpg"
import img20 from "../../Assets/slides/Garden Tomb.jpg"
import img21 from "../../Assets/slides/Golgotha.jpg"
import img22 from "../../Assets/slides/Grotto.jpg"
import img23 from "../../Assets/slides/Haifa.jpg"
import img24 from "../../Assets/slides/Holy Mary Church in Egypt.jpg"
import img26 from "../../Assets/slides/Joppa City.jpg"
import img27 from "../../Assets/slides/tour1.jpg"
import img28 from "../../Assets/slides/Last Supper Room.jpg"
import img29 from "../../Assets/slides/lazarusgrab.jpg"
import img30 from "../../Assets/slides/Madaba & St Georges Church.jpg"
import img31 from "../../Assets/slides/Mara & Elim - Moses Well.jpg"
import img33 from "../../Assets/slides/Mary's Well.jpg"
import img34 from "../../Assets/slides/Mediterranean Sea.jpg"
import img35 from "../../Assets/slides/Mensa Christi , Capernaum.jpg"
import img36 from "../../Assets/slides/Moses Well.jpg"
import img37 from "../../Assets/slides/Mount Carmel.jpg"
import img38 from "../../Assets/slides/tour3.jpg"
import img39 from "../../Assets/slides/Mount Olives.jpg"
import img40 from "../../Assets/slides/Mount Tabor Site of Transfiguration.jpg"
import img41 from "../../Assets/slides/Mount Temptation.jpg"
import img42 from "../../Assets/slides/muharaga.jpg"
import img43 from "../../Assets/slides/Nazareth.jpg"
import img44 from "../../Assets/slides/Pillar of Salt.jpg"
import img45 from "../../Assets/slides/Pool of Bethesda.jpg"
import img46 from "../../Assets/slides/Pyramids & Sphinx.jpg"
import img47 from "../../Assets/slides/Read Sea.jpg"
import img48 from "../../Assets/slides/River Jabbok - Jacob Wrestles With God.jpeg"
import img49 from "../../Assets/slides/tour9.jpg"
import img50 from "../../Assets/slides/Simon The Tanner St Peters Church.jpg"
import img51 from "../../Assets/slides/Sycamore Tree.jpg"
import img52 from "../../Assets/slides/Taba Border Crossing.jpg"
import img53 from "../../Assets/slides/Tabgha Church of Primacy of Peter.jpg"
import img54 from "../../Assets/slides/Tomb Of King David.jpg"
import img55 from "../../Assets/slides/Via Dolorasa 14 Station.jpg"
import img56 from "../../Assets/slides/Western Wailing Wall.jpg"
import img57 from "../../Assets/slides/bahai gardens.jpg"
import img59 from "../../Assets/slides/caiaphas-home-1.jpg"

export const data = [
    {
        img: img57,
        title: "Bahai Gardens",
        description: "The Bahai Gardens in Jerusalem are a stunning complex of terraced gardens that are an iconic feature of the city. Here are some key points about them:",
        link: "bahaigardens",
    },
    {
        img: img1,
        title: "Bahai Shrine",
        description: "The Bahá'í Shrine refers specifically to the Shrine of the Báb, located on Mount Carmel in Haifa, Israel. Here's an overview of the geographical details, historical significance",
        link: "bahaiShrine",
    },
    {
        img: img2,
        title: "Basilica of Annunciation",
        description: "The Basilica of the Annunciation is a prominent Christian pilgrimage site located in Nazareth, Israel. Here's an exploration of its geographical details, biblical references, and explanations",
        link: "basilica",
    },
    {
        img: img3,
        title: "Beattitudes in Jerusalem",
        description: "The Beatitudes are a set of teachings by Jesus that appear in the Gospel of Matthew (Matthew 5:3-12) and the Gospel of Luke (Luke 6:20-23). These teachings are considered foundational to Christian ethics and spiritual values.",
        link: "attitudes",
    },
    {
        img: img4,
        title: "Bethany",
        description: "Bethany is a village located on the eastern slope of the Mount of Olives, about two miles (3 km) southeast of Jerusalem. It is mentioned several times in the New Testament, particularly in relation to Jesus' ministry and interactions with his followers. Here's an overview of Bethany with relevant  ",
        link: "bethany",
    },
    {
        img: img5,
        title: "Bethlehem ",
        description: "Bethlehem holds significant importance in biblical history as the birthplace of Jesus Christ. It is mentioned numerous times in the Bible, particularly in the Old Testament prophecies regarding the Messiah and in the New Testament accounts of Jesus' birth.",
        link: "bethlehem",
    },
    {
        img: img6,
        title: "Burning Bush",
        description: "The Burning Bush is a significant biblical symbol found in the Book of Exodus, associated with the calling of Moses and God's revelation to him. Here's an overview with relevant Bible references and historical",
        link: "burning",
    },
    {
        img: img8,
        title: "Cairo",
        description: "Cairo, the capital of Egypt, holds significance in biblical history, primarily in relation to events involving the Israelites and other ancient peoples of the region. However, it's important to note that while Egypt is mentioned numerous times in the Bible, ",
        link: "cairo",
    },
    {
        img: img9,
        title: "Cairo Museum",
        description: "The Cairo Museum, officially known as the Egyptian Museum, is one of the most famous and important museums in the world, dedicated to showcasing the rich heritage and history of ancient Egypt.",
        link: "cairoMuseum",
    },
    {
        img: img10,
        title: "Canaan",
        description: "Canna in Jerusalem is a reference to the biblical town of Cana, located in the region of Galilee, which is mentioned in the New Testament",
        link: "canaan",
    },
    {
        img: img11,
        title: "Church Of Nativity",
        description: "The Church of the Nativity, located in Bethlehem, is one of the oldest continuously operating churches in the world and holds deep significance as the traditional birthplace of Jesus Christ. ",
        link: "churchNativity",
    },
    {
        img: img12,
        title: "St’Peter of Gallicantu",
        description: "The Church of St. Peter in Gallicantu is a Roman Catholic church located on the eastern slope of Mount Zion in Jerusalem.",
        link: "stPeter",
    },
    {
        img: img13,
        title: "David & Goliath Valey (Elah Valley)",
        description: "The valley associated with the David and Goliath story is commonly understood to be Elah Valley (also known as the Valley of Elah), a geographical location in Israel. ",
        link: "davidGoliath",
    },
    {
        img: img14,
        title: "Dead Sea",
        description: "The Dead Sea, also known as the Salt Sea, is a remarkable geographical feature located in the Middle East, bordered by Jordan to the east and Israel and the West Bank to the west",
        link: "dead",
    },
    {
        img: img15,
        title: "Dome of the Rock Temple Mount in Jerusalem",
        description: "The Dome of the Rock, situated on the Temple Mount in Jerusalem, is a significant religious and architectural landmark in both Islamic and Jewish traditions",
        link: "dome",
    },
    {
        img: img16,
        title: "Dominous Flevit in Jerusalem",
        description: "Dominus Flevit is a Roman Catholic church located on the Mount of Olives in Jerusalem. It is one of the significant Christian pilgrimage sites in the city, commemorating an event in the life of Jesus Christ as recorded in the New Testament. ",
        link: "dominoues",
    },
    {
        img: img17,
        title: "Elisha Springs in Jerusalem",
        description: "Elisha's Spring, also known as Ain es-Sultan or Elisha's Fountain, is a historical and biblical site located near the ancient city of Jericho in the West Bank, rather than in Jerusalem",
        link: "elisha",
    },
    {
        img: img18,
        title: "Galiliean Boad Ride",
        description: "The 'Galilean boat ride' refers to a historical and geographical context associated with the Sea of Galilee (Lake Kinneret) in Israel, particularly focusing on the biblical narratives involving Jesus and his disciples. Here's an exploration",
        link: "galilean",
    },
    {
        img: img19,
        title: "Garden of Gathsemane",
        description: "Garden of Gathsemane ",
        link: "gardenGethsemane",
    },
    {
        img: img20,
        title: "Garden Tomb",
        description: "The Garden Tomb is an important and popular Christian site located outside the walls of the Old City of Jerusalem ",
        link: "gardenTomb",
    },
    {
        img: img21,
        title: "Golgotha",
        description: "Golgotha, also known as Calvary, is the biblical site where Jesus Christ was crucified. The name Golgotha is derived from Aramaic and Hebrew words meaning skull, possibly referring to the skull-like shape of the hill or the existence of a skull-shaped rock formation in the area",
        link: "golgotha",
    },
    {
        img: img22,
        title: "Grotto",
        description: "The Grotto of the Nativity is a cave beneath the Church of the Nativity in Bethlehem, traditionally regarded as the birthplace of Jesus Christ ",
        link: "grotto",
    },
    {
        img: img23,
        title: "Haifa",
        description: "Haifa is a coastal city in northern Israel, known for its historical, cultural, and religious significance ",
        link: "haifa",
    },
    {
        img: img24,
        title: "Holy Mary Church in Egypt",
        description: " The Holy Mary Church, also known as the Church of the Virgin Mary, holds significant religious and historical importance in Egypt.",
        link: "holy",
    },
    {
        img: img59,
        title: "House of Caiphas",
        description: "The House of Caiaphas, also known as the High Priest's Palace, is an archaeological site located on the eastern slope of Mount Zion in Jerusalem. It is traditionally believed to be the residence of Caiaphas",
        link: "houseofcaiphas",
    },
    {
        img: img26,
        title: "Joppa City",
        description: "Joppa, also known as Jaffa (modern-day Jaffa), is an ancient port city located on the Mediterranean coast of Israel",
        link: "joppa",
    },
    {
        img: img27,
        title: "Jordan River",
        description: "The River Jordan holds immense significance in Christianity, particularly in the context of the baptism of Jesus Christ. According to the Bible, specifically...",
        link: "jordanriver",
    },
    {
        img: img28,
        title: "Last Supper Room",
        description: "The Last Supper Room, also known as the Upper Room or Cenacle, is traditionally believed to be the site of Jesus Christ's last supper with his disciples before his crucifixion",
        link: "superRomm",
    },
    {
        img: img29,
        title: "Lazarus Tomb",
        description: "The tomb of Lazarus, the man whom Jesus famously raised from the dead, is a significant site in Christian tradition",
        link: "lazarus",
    },
    {
        img: img30,
        title: "Madaba & St Georges Church",
        description: "Madaba is an ancient city in Jordan known for its Byzantine and Umayyad mosaics, particularly the famous mosaic map of the Holy Land. St. George's Church, located in Madaba, houses this renowned mosaic among other historical artifacts.",
        link: "madaba",
    },
    {
        img: img31,
        title: "Mara & Elim",
        description: "The stories of Marah and Elim are found in the Book of Exodus in the Bible, specifically in Exodus 15:22-27. These events occurred during the Israelites' journey from Egypt to the Promised Land ",
        link: "maraelim",
    },
    {
        img: img33,
        title: "Mary's Well",
        description: "Mary's Well, or Bir Maryam in Arabic, is traditionally associated with a site in the old city of Nazareth, not in Jerusalem",
        link: "marysWell",
    },
    {
        img: img34,
        title: "Mediterranean Sea",
        description: "The Mediterranean Sea is a large body of water located between Europe, Africa, and Asia, known for its historical, cultural, and geographical significance",
        link: "mediterranean",
    },
    {
        img: img35,
        title: "Mensa Christi , Capernaum",
        description: "The Mensa Christi (Table of Christ) refers to a traditional site located in Capernaum, not in Jerusalem",
        link: "mensa",
    },
    {
        img: img36,
        title: "Moses Well",
        description: "The Well of Moses, also known as the Spring of Moses or Ain Musa in Arabic, is a significant site in the Sinai Peninsula traditionally associated with the biblical figure of Moses.",
        link: "moses",
    },
    {
        img: img37,
        title: "Mount Carmel",
        description: "Mount Carmel is a prominent mountain range in northern Israel, extending along the Mediterranean Sea near the city of Haifa. It holds significant geographical, historical, and biblical importance.",
        link: "mtCarmel",
    },
    {
        img: img38,
        title: "Mount Nebo",
        description: "Mount Nebo is a significant biblical site located in present-day Jordan, near the city of Madaba. It holds great religious importance, particularly in Judaism and Christianity",
        link: "mountnebo",
    },
    {
        img: img39,
        title: "Mount Olives",
        description: "Mount Olivet, also known as the Mount of Olives, is a prominent geographic feature located to the east of Jerusalem. It holds significant religious and historical importance in Judaism, Christianity, and Islam.",
        link: "mountolives",
    },
    {
        img: img40,
        title: "Tabor Site of Transfiguration",
        description: "Mount Tabor is a significant biblical and geographical landmark located in Lower Galilee, Israel. It is traditionally believed to be the site of the Transfiguration of Jesus Christ, an event described in the New Testament Gospels of Matthew, Mark, and Luke.",
        link: "mtTabor",
    },
    {
        img: img41,
        title: "Mount Temptation",
        description: "Mount Temptation, also known as the Mount of Temptation, is a prominent geographical feature near the city of Jericho in the West Bank.",
        link: "mtTemptation",
    },
    {
        img: img42,
        title: "Muharaga",
        description: "Muharraqa likely refers to Mount Carmel (Jebel Mar Elyas), an important geographical and historical site in Israel. ",
        link: "muharaga",
    },
    {
        img: img43,
        title: "Nazareth",
        description: "Nazareth is a city in the northern region of Israel, known primarily as the childhood home of Jesus Christ",
        link: "nazareth",
    },
    {
        img: img44,
        title: "Pillar of Salt",
        description: "The story of the Pillar of Salt is found in the Bible, specifically in the book of Genesis, concerning the destruction of Sodom and Gomorrah.",
        link: "pillar",
    },
    {
        img: img45,
        title: "Pool of Bethesda",
        description: "The Pool of Bethesda is a significant location mentioned in the New Testament, particularly in the Gospel of John",
        link: "pool",
    },
    {
        img: img46,
        title: "Pyramids & Sphinx",
        description: " Egypt plays a significant role in the Bible, especially in the narratives of Genesis and Exodus. The Israelites' sojourn in Egypt, the story of Joseph, and the Exodus under Moses are central themes.",
        link: "pyramids",
    },
    {
        img: img47,
        title: "Read Sea",
        description: "The Red Sea holds significant historical and biblical importance. It features prominently in the Old Testament, particularly in the account of the Israelites' exodus from Egypt",
        link: "read",
    },
    {
        img: img48,
        title: "River Jabbok - Jacob Wrestles With God",
        description: "The River Jabbok is a significant geographical and historical feature mentioned in the Bible, primarily in connection with the patriarch Jacob.",
        link: "riverJabbok",
    },
    {
        img: img49,
        title: "Shepards Field in Bethlehem",
        description: "The Shepherd's Fields in Bethlehem hold significant biblical and historical importance, particularly in relation to the birth of Jesus Christ.",
        link: "shephardsfield",
    },
    {
        img: img50,
        title: "Simon The Tanner St Peters Church",
        description: "Simon the Tanner is not explicitly mentioned in the Bible in connection with a church in Jerusalem.",
        link: "simonthetanner",
    },
    {
        img: img51,
        title: "Sycamore Tree",
        description: "The sycamore tree is mentioned in the Bible in relation to the story of Zacchaeus, a tax collector who encounters Jesus in the city of Jericho",
        link: "sycamore",
    },
    {
        img: img52,
        title: "Taba Border Crossing",
        description: "The Taba Border Crossing is a significant border crossing between Egypt and Israel, located near the resort town of Taba in the Sinai Peninsula.",
        link: "taba",
    },
    {
        img: img53,
        title: "Tabgha Church of Primacy of Peter",
        description: "The Church of the Primacy of Peter, also known as the Church of Tabgha, is located in Tabgha on the northwest shore of the Sea of Galilee in Israel, not in Jerusalem.",
        link: "tabgha",
    },
    {
        img: img54,
        title: "Tomb Of King David",
        description: "The Tomb of King David, located on Mount Zion in Jerusalem, is a site traditionally believed to be the burial place of King David, the second king of Israel and Judah.",
        link: "kingDavid",
    },
    {
        img: img55,
        title: "Via Dolorasa 14 Station",
        description: "The Via Dolorosa, meaning Way of Suffering or Way of Sorrows in Latin, is a route in the Old City of Jerusalem that is traditionally believed to be the path that Jesus walked on the way to his crucifixion.",
        link: "via14",
    },
    {
        img: img56,
        title: "Western Wailing Wall",
        description: "The Western Wall, also known as the Wailing Wall, is one of the most sacred sites in Judaism and a significant religious and historical landmark in Jerusalem.",
        link: "western",
    },
]